'use client'

import { useParams } from 'next/navigation'
import { useTexts } from '@/contexts/LanguageContext'
import { useTrustCenterConfig } from '@/contexts/TrustCenterContext'
import SubprocessorsTable from '../../subprocessors/components/SubprocessorsTable'
import { TRUST_CENTER_SECTIONS, trustCenterPath } from '../../utils'
import SectionHeader from './SectionHeader'

const MAX_SUBPROCESSORS_TO_SHOW = 5

export default function SubprocessorsOverview() {
  const { SUBPROCESSORS } = useTexts().PUBLIC_TRUST_CENTER.OVERVIEW
  const { subprocessors } = useTrustCenterConfig()
  const { orgToken } = useParams<{ orgToken: string }>()
  if (subprocessors.length === 0) return null
  return (
    <section className="flex flex-col gap-3.5">
      <SectionHeader
        title={SUBPROCESSORS.TITLE}
        subtitle={SUBPROCESSORS.SUBTITLE}
        link={{ href: trustCenterPath(orgToken, TRUST_CENTER_SECTIONS.SUBPROCESSORS), label: SUBPROCESSORS.VIEW_ALL }}
      />
      <SubprocessorsTable subprocessors={subprocessors.slice(0, MAX_SUBPROCESSORS_TO_SHOW)} />
    </section>
  )
}
